export function successMessage(VM, title, content) {
  return new Promise((resolve, reject) => {
    VM.$bvModal
      .msgBoxOk(content, {
        title: title,
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      })
      .then(() => {
        resolve("成功");
      })
      .catch(() => {
        reject("失敗");
      });
  });
}

export function errorMessage(VM, title, content) {
  VM.$bvModal.msgBoxOk(content, {
    title: title,
    size: "sm",
    buttonSize: "sm",
    okVariant: "danger",
    headerClass: "p-2 border-bottom-0",
    footerClass: "p-2 border-top-0",
    centered: true,
  });
}
